import { useState } from 'react';
import Header from '../../../Components/Header/Header';
import styles from './contact.module.scss';
import { Helmet } from 'react-helmet-async';
import useInView from '../../../Components/UseInView/useInView';
import Cta from '../../../Components/Cta/Cta';
import Footer from '../../../Components/Footer/Footer';
import instagram from '../../../Assets/Images/Icons/Social/instagram.png';
import facebook from '../../../Assets/Images/Icons/Social/facebook.png';
import tiktok from '../../../Assets/Images/Icons/Social/tik-tok.png';
import InputField from '../../../Components/InputField/InputField';
import RevealImage from '../../../Components/RevealImage/revealImage';
import TextArea from '../../../Components/TextArea/TextArea';
import Button from '../../../Components/Button/Button';
// import { handleError } from '../../../Services/api.service';

const Contact = () => {
    const [contactEmail, setContactEmail] = useState(ContactEmail);
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    // const [loading, setLoading] = useState(false);
    const [contactLandingRef, contactLandingVisible] = useInView();
    const [formRef, formVisible] = useInView();

    const submitForm = async () => {
        if (contactFormValidator(contactEmail, setErrors)) {
            // setLoading(true);
            // setSubmitted(true);
            // try {
            //     const response = await contactFormSubmit(contactEmail);
            //     if (response.status === 200) {
            //         setResponseMessage(response.data.message);
            //     }
            // } catch (error) {
            //     if (error.response?.status === 405) {
            //         setResponseMessage(error.response.data.message);
            //     } else {
            //         setResponseMessage('There was a problem submitting your request.');
            //     }
            // }
            // setLoading(false);
        } else {
            setSubmitted(true);
            setResponseMessage('There was an error, check fields.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>
            <Header />

            <p>[Contact Us]</p>
            <h1>Let's Chat Today</h1>

            <div
                id='Contact Landing'
                ref={contactLandingRef}
                className={`${styles.contactLandingContainer} ${contactLandingVisible ? styles.visible : ''}`}
            >
                <div className={styles.socialBox}>
                    <h3>LOCATION</h3>
                    <p>25 Groff Pl Unit 6B, Kitchener ON</p>
                </div>
                <div className={styles.socialBox}>
                    <h3>CONTACT US</h3>
                    <p>
                        contact@clearmanagement.ca
                        <br />
                        +1 226 600 9243
                    </p>
                </div>
                <div className={styles.socialBox}>
                    <h3>FOLLOW US</h3>
                    <div className={styles.socialLinks}>
                        <a
                            href='https://www.instagram.com/clearcontracting.ca'
                            target='_blank'
                            rel='noreferrer'
                        >
                            <img src={instagram} alt='Instagram' />
                        </a>
                        <a
                            href='https://www.instagram.com/clearcontracting.ca'
                            target='_blank'
                            rel='noreferrer'
                        >
                            <img src={facebook} alt='facebook' />
                        </a>
                        <a
                            href='https://www.instagram.com/clearcontracting.ca'
                            target='_blank'
                            rel='noreferrer'
                        >
                            <img src={tiktok} alt='tiktok' />
                        </a>
                    </div>
                </div>
            </div>

            <div
                id='Contact Form'
                ref={formRef}
                className={`${styles.contactForm} ${formVisible ? styles.visible : ''}`}
            >
                <div className={styles.contactFormLeft}>
                    <InputField
                        label='Full Name'
                        path='user.png'
                        onChange={(e) => setContactEmail({ ...contactEmail, name: e.target.value })}
                        value={contactEmail.name}
                        error={errors.name}
                    />
                    <InputField
                        label='Email'
                        path='email.png'
                        onChange={(e) =>
                            setContactEmail({ ...contactEmail, email: e.target.value })
                        }
                        value={contactEmail.email}
                        error={errors.email}
                    />
                    <InputField
                        label='Phone'
                        path='telephone.png'
                        onChange={(e) =>
                            setContactEmail({ ...contactEmail, phone: e.target.value })
                        }
                        value={contactEmail.phone}
                        error={errors.phone}
                    />
                    <TextArea
                        label='Message'
                        onChange={(e) =>
                            setContactEmail({ ...contactEmail, message: e.target.value })
                        }
                        value={contactEmail.message}
                        error={errors.message}
                    />
                    <Button
                        buttonText='Submit Now'
                        displayIcon={true}
                        onClick={submitForm}
                        submitted={submitted}
                        loading={false}
                        responseMessage={responseMessage}
                        customStyle={{ marginTop: 'min(5vw, 30px)' }}
                    />
                </div>
                <div className={styles.contactFormRight}>
                    <RevealImage
                        src='https://cdn.prod.website-files.com/6787fd6e047993a568043b60/6787fd6e047993a568043bf9_details-image-01.jpg'
                        alt='landing'
                        imageStyle={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                        rollUpColor='#f6f6f6'
                    />
                </div>
            </div>

            <div id='Cta' className={`${styles.sectionContainer} ${styles.visible}`}>
                <Cta />
            </div>

            <Footer />
        </>
    );
};

export default Contact;

const ContactEmail = {
    name: '',
    email: '',
    phone: '',
    message: '',
};

const contactFormValidator = (formData, setErrors) => {
    const { name, email, phone, message } = formData;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9+\-\s()]{7,20}$/; // digits, +, -, space, parentheses

    const errors = {
        name: !name.trim(),
        email: !email.trim() || !emailRegex.test(email),
        phone: !phone.trim() || !phoneRegex.test(phone), // <- phone now required
        message: !message.trim(),
    };

    setErrors(errors);

    // returns true only if every field passed
    return !Object.values(errors).some(Boolean);
};
